import { render, staticRenderFns } from "./TasksPage.vue?vue&type=template&id=10d0edd0&scoped=true&"
import script from "./TasksPage.vue?vue&type=script&lang=js&"
export * from "./TasksPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d0edd0",
  null
  
)

export default component.exports